const MAIN_URL = 'https://george-fx.github.io/apitex_api/';

const GET_USERS = `${MAIN_URL}api/users.json`;
const GET_STATISTICS = `${MAIN_URL}api/statistics.json`;
const GET_TRANSACTIONS = `${MAIN_URL}api/transactions.json`;

export const URLS = {
  GET_USERS,
  GET_STATISTICS,
  GET_TRANSACTIONS,
};
